<template>
  <header v-bind:id="menuItem.anchor" class="parallax-window" data-parallax="scroll" data-image-src="/static/img/banner.jpg">
    <div class="overlay">
      <div class="titleContainer">
        <div class="main-title text-center">
          <!-- Main title -->
          <h1 class="light mb-15">{{collection.title}}</h1>
          <h3 class="light opas mb-30">{{collection.subTitle}}</h3>
          <br/>
          <a href="/#infoEltern" data-anchor="#infoEltern" class="button button-3 mr-1">Für<br/>Eltern<i class="fas fa-chevron-right hidemobile"></i></a>
          <a href="/#infoJugendliche" data-anchor="#infoJugendliche" class="button button-3 mr-1">Für<br/>Jugendliche<i class="fas fa-chevron-right hidemobile"></i></a>
        </div>
      </div>
     
      <!-- Scroll hint 
      <a href="#office" data-anchor="#office" class="hint" style="opacity: 1; transform: translateY(0px);"><i
        class="scroll-hint jump fas fa-chevron-down"></i></a>
        -->
    </div>
  </header>
</template>

<script>
  import 'jquery-parallax.js'

  export default {
    components: {
    },
    data () {
      return {
        collection: {'title': 'Herzlich Willkommen auf den Seiten der Praxis Nicolas Mandt', 'subTitle': 'tiefenpsychologisch fundierte Psychotherapie für Kinder, Jugendliche und junge Erwachsene', 'backgroundImage': {'path': '/cockpit/storage/uploads/2019/03/01/5c7909eec0412banner.jpg'}, '_mby': '5c78dbb16435630838000192', '_by': '5c78dbb16435630838000192', '_modified': 1551441773, '_created': 1551436280, '_id': '5c7909f8643563083800016d', 'arrowTarget': '/#service'}
      }
    },
    props: ['menuItem'],
    computed: {
      baseUrl () {
        return this.$store.getters.baseUrl()
      }
    },
    mounted () {
      this.$http.get(this.$store.getters.serviceClient().getCollectionUrl(this.$props.menuItem.collection))
        .then((response) => {
          if (response.ok) {
            console.log(response.body.entries)
            this.$data.collection = response.body.entries[0]
          }
        })
        .catch((error) => {
          console.log(error)
        })

      // Parallax
      $('.parallax-window').parallax({
        zIndex: -100
      })
    },
    methods: {}
  }
</script>

<style scoped="scoped">
  h1 {
    font-family: 'Roboto Slab', serif;
    opacity: 1;
    transform: translateY(0px);
  }
  h3 {
    font-family: 'Raleway', sans-serif;
    opacity: 1;
    transform: translateY(0px);
    font-size: 1.5em;
    font-weight: 300;
  }

  header {
    background-size: cover;
    background-position: center;
  }

  header .overlay {
    position: relative;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-line-pack: center;
    align-content: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    padding-top: 70px;
    height: 100vh;
    /*width: 100vw;*/
  }

  header .titleContainer {
    -ms-flex-item-align: center;
    align-self: center;
    padding-left: 1em;
    padding-right: 1em;
  }

  .parallax-window {
    background-color: transparent;
  }
</style>



// WEBPACK FOOTER //
// src/components/sections/ParallaxImage.vue